module.exports = __webpack_public_path__ + "static/img/ysrz_selected_image.83daaef.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/supplyFinance/ysrz_selected_image.png
// module id = i6bG
// module chunks = 44